export const MockActions = {
  get: (path, callback) => {
    if (mocks[path]) {
      callback(mocks[path]);

      return true;
    }
  },
};

export const mocks = {
  'enums/transactionType': ['PAYMENT', 'REFUND', "DEPOSIT_PAYMENT", "DEPOSIT_REFUND"],
  'enums/legalDocumentCode': ['TERMS_OF_SERVICE', 'PRIVACY_POLICY', 'CANCELLATION_POLICY'],

  // "toolSetOrder/generate": "20250117-1",
};
